import moment from "moment";

export default {
  /**
   * function for storing the data in localStorage
   */
  setData: (key, data) => {
    if (data) {
      localStorage.setItem(key, JSON.stringify(data));
    }
  },

  /**
   * function for getting the data from localStorage
   */
  getData: (key) => {
    if (key && localStorage.getItem(key)) {
      return JSON.parse(localStorage.getItem(key));
    }
    return null;
  },

  /**
   * function for clearing particular key from localStorage
   */
  clearData: (key) => {
    localStorage.removeItem(key);
  },

  /**
   * function for clearing all data from localStorage
   */
  clearAllData: () => {
    localStorage.clear();
  },

  /**
   * function to convert date time to mm/dd/yyyy
   */

  getDate: (datetime) => {
    let offset = moment.parseZone(datetime).utcOffset();
    let date = moment.utc(datetime).utcOffset(offset).format("MM/DD/YYYY");
    return date;
  },
  compareDate: (datetime) => {
    let licenseEndDate = new Date(datetime);
    var todayDate = new Date();
    let isActive = false;
    if (todayDate < licenseEndDate) isActive = true;
    else if (todayDate > licenseEndDate) isActive = false;
    else isActive = true;
    return isActive;
  },

  isValidName: (value) => {
    let alphaRegex = new RegExp(/^[A-Za-z]+$/);
    if (!alphaRegex.test(value)) return false;
    else return true;
  },

  isValidEmail: (email) => {
    let emailRegex = new RegExp(
      // eslint-disable-next-line no-useless-escape
      /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ); // eslint-disable-line
    if (!emailRegex.test(email)) return false;
    else return true;
  },

  isValidPassword: (password) => {
    let upperCharacterRegex = new RegExp("[A-Z]");
    let lowerCharacterRegex = new RegExp("[a-z]");
    let specialCharacterRegex = new RegExp("[$@$!%*#?&]");
    let numericRegex = new RegExp("[0-9]");
    let resObj = {
      lengthError: false,
      characterValueError: false,
      numericValueError: false,
      specialCharacterError: false,
    };
    if (password.length < 8 || password.length > 20) {
      resObj.lengthError = true;
    }
    if (
      !upperCharacterRegex.test(password) ||
      !lowerCharacterRegex.test(password)
    ) {
      resObj.characterValueError = true;
    }
    if (!specialCharacterRegex.test(password)) {
      resObj.specialCharacterError = true;
    }
    if (!numericRegex.test(password)) {
      resObj.numericValueError = true;
    }
    return resObj;
  },
};



// WEBPACK FOOTER //
// ./src/common/utility.js